import { Box, FormControl, FormLabel, Switch } from "@mui/material";
import React from "react";

function NCXFormBoolean(props) {
    const fieldname = props?.field?.properties?.fieldname;
    const onSwitched = (checked) => {
        props?.handleInputChange(fieldname, checked, props?.field)
    }

    return (
        <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
            <FormControl disabled={props?.field?.properties?.readOnly}>
                <FormLabel>{props?.field?.properties?.label}</FormLabel>
                <Switch onChange={(e,v) => onSwitched(v)} />
            </FormControl>
        </Box>
    )
}

export default NCXFormBoolean;